import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import { createContext, type ReactNode, useContext } from 'react';
import { EntityIdProvider } from '@/entity/hooks/use-entity-id';
const ArtifactEntityContext = createContext<Entity | undefined>(undefined);
const useArtifactEntity = () => {
  return useContext(ArtifactEntityContext);
};
const ArtifactEntityProvider = t0 => {
  const $ = _c(6);
  const {
    entity,
    children
  } = t0;
  const t1 = entity?.id;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <EntityIdProvider value={t1}>{children}</EntityIdProvider>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== entity || $[4] !== t2) {
    t3 = <ArtifactEntityContext.Provider value={entity}>{t2}</ArtifactEntityContext.Provider>;
    $[3] = entity;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { ArtifactEntityProvider, useArtifactEntity };